import React, { useState } from "react";
import { Col, Card, CardBody, Button, Spinner } from "reactstrap";
import placeholderImage from "assets/images/img.png";
import Dropzone from "Components/Form/DropZone";
import EditModal from "./EditTagsModal";
import { updateFeaturedImage } from "helpers/API Calls/Operations/Products";
import { MediaItem } from "./ImageGallery";
import DeleteModal from "Components/Modals/DeleteModal";

interface MediaHolderProps {
  media: MediaItem;
  onMediaUpload: (file: File, type: "image" | "video") => void;
  onDeleteMedia: () => void;
  onSave: (id:number) => void;
  loading: boolean;
  productId: number;
}

function MediaHolder({ media, onMediaUpload, onDeleteMedia, loading, onSave, productId}: MediaHolderProps) {

  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const toggleEditModal = () => setEditModalOpen(prev => !prev);  

  const handleSaveEdit = async (id: number) => {
    const data = {featured_image_id: id}
    const response = await updateFeaturedImage(productId, data)
    if (response.success){
      onSave(id)
    }
    toggleEditModal();
  };

  return (
    <>
    <EditModal
      isOpen={editModalOpen}
      toggle={toggleEditModal}
      media={media}
      onSave={handleSaveEdit}
    />
    {deleteModal && <DeleteModal
      show={deleteModal}
      onDeleteClick={() => {setDeleteModal(false); onDeleteMedia();}}
      onCloseClick={() => {setDeleteModal(false);}}
      message='media'
    />}

    <Col>
      <Card className="p-0 mb-0" style={{ width: "auto" }}>
        <CardBody className="p-0">
          <div className="text-center position-relative">
            {/* Conditionally apply dropzone only for empty media slots */}
            {media?.file_url ? (
              <div className="avatar-xl rounded">
                <div className="avatar-title bg-light">
                  <img
                    src={media?.file_url}
                    id={`${media?.id}-img`}
                    alt=""
                    className="avatar-xl rounded h-100"
                  />
                </div>
              </div>
            ) : (
            <>
              <Dropzone
                accept = {{"image/*": [".png", ".jpeg", ".jpg", ".gif"],}}
                onDrop = {(acceptedFiles) => {
                  if (acceptedFiles.length === 0) return;
                  const file = acceptedFiles[0];
                  const fileType = "image";
                  onMediaUpload(file, fileType); // Send the File object and file type to the parent
                }}
                disabled={!!media?.file_url}
                renderContent = {() => (
                  <div className="avatar-xl rounded">
                  <div className="avatar-title bg-light">
                    <img
                      src={placeholderImage}
                      id="media-placeholder"
                      alt="Placeholder"
                      className="avatar-xl rounded h-100"
                    />
                  </div>
                </div>
                )}
              />
            </>
            )}

            {/* Buttons for viewing and deleting media */}
            {media?.file_url && (
              <div className="position-absolute top-0 end-0">
                <Button type="button" className="btn btn-primary btn-sm p-1 me-1"
                  onClick={() => window.open(media.file_url || '', "_blank")}
                >
                  <i className="mdi mdi-eye-outline"/>
                </Button>

                <Button type="button" className="btn btn-info btn-sm p-1 me-1"
                  onClick={toggleEditModal}
                >
                   <i className="mdi mdi-pencil"/>
                </Button>

                <Button type="button" className="btn btn-danger btn-sm p-1"
                  onClick={() => setDeleteModal(true)} disabled={loading}
                >
                  {loading ? (
                    <Spinner size="sm" />
                  ) : (
                  <i className="mdi mdi-trash-can"/> 
                  )}
                </Button>
              </div>
            )}
          </div>
        </CardBody>
      </Card>
    </Col>
    </>
  );
}

export default MediaHolder;
